module.exports = __webpack_public_path__ + "media/components/Pages/ResultsPage/send-58c6cfdf10121d2833c0188b9f458b00.svg";